export default {
  HighestDailyLimit: 'highestDailyLimit',
  LowestDailyLimit: 'lowestDailyLimit',
}
